export default __webpack_public_path__ + "static/media/logo.5872452c.png";